import { SOURCE_RANK } from "./swaps";
import { orderStreamlineTags } from "./totals";
const METAL_NAMES = {
    1: "Bronze",
    2: "Silver",
    3: "Gold",
};
const CLASS_NAMES = {
    base: "Rare",
};
/** "Gold Rare · 84 OVR": the card's metal from any player in the row, then class and rating. */
export const streamlineBracketLabel = (bracket, metalId) => {
    const metal = metalId === undefined ? undefined : METAL_NAMES[metalId];
    const cls = CLASS_NAMES[bracket.cls] ?? bracket.cls;
    return `${[metal, cls].filter(Boolean).join(" ƒ")} · ${bracket.rating} OVR`;
};
const toOption = (be) => ({
    player: be.player,
    position: be.position,
    price: be.price,
    source: be.source,
    untradeable: be.untradeable,
    eaPlayerId: be.eaPlayerId,
});
const toSolution = (be) => ({
    id: be.id,
    tags: orderStreamlineTags(be.tags),
    totalValue: be.totalValue,
    transferCost: be.transferCost,
    transferCount: be.transferCount,
    ownedCount: be.ownedCount,
    isRecommended: be.recommended,
    timeS: be.timeS,
    brackets: be.brackets.map((bracket) => ({
        bracketId: bracket.bracketId,
        points: bracket.points,
        label: streamlineBracketLabel(bracket, bracket.players[0]?.player.metalId),
        rating: bracket.rating,
        /* One entry per copy: the backend sends identical copies once with a
           count, the screen marks and swaps them one at a time. Grouped by where
           the card sits (duplicates first, market last), then by price, so a card
           is where the user expects to find it. Sorted once here: a swap changes
           a slot's card, not its place in the row. */
        players: bracket.players
            .flatMap((entry) => Array.from({ length: entry.count }, (_, copy) => ({
            ...toOption(entry),
            entryId: `${entry.entryId}:${copy}`,
            points: entry.points,
        })))
            .sort((a, b) => SOURCE_RANK[a.source] - SOURCE_RANK[b.source] || a.price - b.price),
    })),
});
export const toStreamlineSbcSet = (be) => ({
    kind: "STREAMLINE",
    id: be.id,
    name: be.name,
    targetPoints: be.targetPoints,
    solutions: be.solutions.map(toSolution),
});
export const toStreamlineOptions = (be) => Object.fromEntries(Object.entries(be).map(([rating, pool]) => [
    Number(rating),
    { club: pool.club.map(toOption), market: pool.market.map(toOption) },
]));
/** The distinct ratings a set's solutions ask for, the key of its options. */
export const streamlineRatings = (set) => [
    ...new Set(set.solutions.flatMap((solution) => solution.brackets.map((bracket) => bracket.rating))),
];
//# sourceMappingURL=adapter.js.map